<template>
  <v-dialog
    v-model="statusModal"
    width="637px"
    content-class="v-dialog__form">
    <v-card>
      <v-card-title>
        <div class="d-flex align-center">
          Change Email Address
        </div>
        <v-icon
          color="#fff"
          @click="statusModal = false">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="updateLibraryLinks"
          v-model="valid"
          lazy-validation
          @submit.prevent="changeEmail">
          <v-text-field
            v-for="(item,index) in fields"
            :key="item.title"
            v-model="item.value"
            :rules="item.emailRules"
            :label="item.title"
            :prepend-inner-icon="item.icon"
            :append-icon="$v.fields.$each[index].value.$dirty && $v.fields.$each[index].value.$error ? item.iconAppend : ''"
            :disabled="item.disabled"
            class="mb-6"
            @input="$v.fields.$each[index].$touch()"
            @blur="$v.fields.$each[index].$touch()" />
          <v-row
            no-gutters
            justify="end">
            <v-btn
              type="submit"
              color="lightBlue">
              Update
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate';
import {
  required, email,
} from 'vuelidate/lib/validators';
import API from '@/services/GraphQl';
import {
  mapMutations, mapActions,
} from 'vuex';
export default {
  name: 'ChangeEmailModal',
  mixins: [validationMixin],
  data() {
    return {
      valid: true,
      statusModal: false,
      userId: '',
      fields: [{
        title: 'Current Email Address',
        value: '',
        icon: 'mdi-at',
        disabled: true,
        emailRules: [
          () => this.$v.fields.$each[0].value.required || 'E-mail is required',
          () => this.$v.fields.$each[0].value.email || 'E-mail must be valid',
        ],
        iconAppend: 'mdi-alert-circle-outline',
      },
      {
        title: 'New Email Address',
        value: '',
        icon: 'mdi-at',
        emailRules: [
          () => this.$v.fields.$each[1].value.required || 'E-mail is required',
          () => this.$v.fields.$each[1].value.email || 'E-mail must be valid',
        ],
        iconAppend: 'mdi-alert-circle-outline',
      },
      {
        title: 'Confirm Email Address',
        value: '',
        icon: 'mdi-at',
        emailRules: [
          () => this.$v.fields.$each[2].value.required || 'E-mail is required',
          () => this.$v.fields.$each[2].value.email || 'E-mail must be valid',
          (v) => v === this.$v.fields.$each[1].value.$model || 'E-mail must be identical.',
        ],
        iconAppend: 'mdi-alert-circle-outline',
      },
      ],
    };
  },
  validations: {
    fields: {
      $each: {
        value: {
          required,
          email,
        },
      },
    },
  },
  methods: {
    ...mapActions(['handleError']),
    ...mapMutations(['spinner']),
    async showModal(userId, email, users) {
      this.userId = userId;
      this.statusModal = true;
      await this.$nextTick();
      await this.$refs.updateLibraryLinks.reset();
      this.$set(this.fields[0], 'value', email);
      this.$v.fields.$each.$reset();
    },
    async changeEmail() {
      this.$v.fields.$each.$touch();
      const errors = await this.$refs.updateLibraryLinks.validate();
      if (!errors) {
        return false;
      }
      try {
        this.spinner(true);
        const response = await API.changeEmailAddress({
          userId: this.userId, email: this.fields[1].value,
        });
        this.$emit('updateUserEmail', response.data.changeEmailAddress);
      } catch (e) {
        this.handleError(e);
      } finally {
        this.spinner(false);
        this.statusModal = false;
      }
    },
  },
};
</script>
<style scoped>
</style>
